var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Experiencia laboral"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -271,
    y: -96,
    width: 608,
    height: 502,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_184_5699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 66
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "023de3ec0d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H66V66H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_184_5699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66 33C66 51.2256 51.2256 66 33 66C14.7744 66 0 51.2256 0 33C0 14.7744 14.7744 0 33 0C51.2256 0 66 14.7744 66 33Z",
    fill: "#0C85D0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_184_5699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 44,
    height: 50
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "3ecc58565b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.8438 17.8213H66.0013V66.0008H23.8438V17.8213Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_184_5699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_184_5699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 66
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "e6f1f90927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66 33C66 51.2256 51.2256 66 33 66C14.7744 66 0 51.2256 0 33C0 14.7744 14.7744 0 33 0C51.2256 0 66 14.7744 66 33Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_184_5699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.6852 44.5073L54.0461 17.8672L23.8613 48.2165L48.028 72.3822L80.6852 44.5073Z",
    fill: "#0772B4"
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.6588 18.3258C52.7928 17.4712 51.6428 17 50.4192 17C49.1956 17 48.0447 17.4712 47.1796 18.3258L27.1903 38.0718L18.8183 29.8017C17.9532 28.9471 16.8022 28.4769 15.5786 28.4769C14.3551 28.4769 13.2051 28.9471 12.34 29.8017C10.5533 31.5656 10.5533 34.4372 12.34 36.2011L23.9086 47.6289C23.921 47.6421 23.9344 47.6563 23.9506 47.6723C24.1705 47.8886 24.4123 48.085 24.6695 48.2521C25.4189 48.7413 26.2917 49 27.1941 49C28.4177 49 29.5676 48.5288 30.4318 47.6752C30.4748 47.6336 52.7115 25.6601 53.6588 24.7252C54.5239 23.8706 55 22.7347 55 21.525C55 20.3163 54.5239 19.1804 53.6588 18.3258Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDone);
export default __webpack_public_path__ + "static/media/ic_done.143eeb16b39725fce715a46d5817bb74.svg";
export { ForwardRef as ReactComponent };